import { Component } from "@angular/core";
import { NavController, NavParams, Platform } from "ionic-angular";
import { ConfigService } from "../../services/config.service";

@Component({
  selector: "page-fannel-info",
  templateUrl: "fannel-info.html",
})
export class FannelInfoPage {
  ios: boolean;
  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private configService: ConfigService,
    private platform: Platform
  ) {
    if (this.platform.is("ios")) {
      this.ios = true;
    } else {
      this.ios = false;
    }
    this.ios = false;
  }

  ionViewDidLoad() {
    console.log("ionViewDidLoad FannelInfoPage");
  }

  goBack() {
    this.navCtrl.pop();
  }
}



// WEBPACK FOOTER //
// ./src/pages/fannel-info/fannel-info.ts